export default{
	getWeek(date){
		var one_day = 86400000;
		var day = date.getDay();
		var weekList = [];
		if(date.getDay()=="0"){
			var week_start_time = date.getTime() - 6 * one_day;
			var week_end_time = date.getTime() ;
		}else {
			var week_start_time = date.getTime() - (day - 1) * one_day;
			var week_end_time = date.getTime() + (7 - day) * one_day;
		}
		
		var month1 = new Date(week_start_time).getMonth()+1;
		var month2 = new Date(week_end_time).getMonth()+1;
		var day1 = new Date(week_start_time).getDate();
		var day2 = new Date(week_end_time).getDate();
		var year1 = new Date(week_start_time).getFullYear();
		var year2 = new Date(week_end_time).getFullYear();
		if(month1<10){
			month1 = "0"+month1;
		}
		if(month2<10){
			month2 = "0"+month2;
		}
		if(day1<10){
			day1 = "0"+day1;
		}
		if(day2<10){
			day2 = "0" + day2;
		}
		weekList.push(day1)
		
		var myDate = date.getDate()
		var date1 = new Date(week_start_time)
		for(var i = 0;i< 6;i++){
			date1.setDate(date1.getDate() + 1);
			myDate = date1.getDate()
			if(date1.getDate()<10){
				myDate= '0'+ myDate;
			}
			weekList.push(myDate);
		}
		// this.weekDayList = weekList;
		// this.showTime1 = year1+'年'+month1+"月"+day1+'日';
		// this.showTime2 = +month2+"月"+day2+'日';
		// this.start_date = year1+'-'+month1+'-'+day1;
		// this.end_date = year2+'-'+month2+'-'+day2;
	},
}